export default function React_Suspense() {
  return (
    <div>
      <h1>React_Suspense Component</h1>
      <p>This is the React_Suspense tutorial page.</p>
    </div>
  );
}
